import { useState } from 'react';

import { useNotify } from '@/hooks/useNotify';

import { BULK_MAX_SELECTION } from '../constants';

/**
 * Estado de selección múltiple del listado de protocolos (checkboxes + bulk actions).
 * Vive como state local del componente contenedor del listado.
 */
export function useProtocolosSelection() {
  const notify = useNotify();
  const [selected, setSelected] = useState<Set<string>>(new Set());

  function toggle(uid: string): void {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(uid)) {
        next.delete(uid);
        return next;
      }
      if (next.size >= BULK_MAX_SELECTION) {
        notify.info(`Solo podés seleccionar hasta ${BULK_MAX_SELECTION} protocolos a la vez.`);
        return prev;
      }
      next.add(uid);
      return next;
    });
  }

  /** Selecciona/deselecciona todos los `uids` dados (los cargados actualmente en pantalla). */
  function toggleAll(uids: string[]): void {
    setSelected((prev) => {
      const allSelected = uids.length > 0 && uids.every((uid) => prev.has(uid));
      if (allSelected) {
        const next = new Set(prev);
        for (const uid of uids) next.delete(uid);
        return next;
      }
      if (uids.length > BULK_MAX_SELECTION) {
        notify.info(`Solo podés seleccionar hasta ${BULK_MAX_SELECTION} protocolos a la vez.`);
        return new Set(uids.slice(0, BULK_MAX_SELECTION));
      }
      return new Set(uids);
    });
  }

  function clear(): void {
    setSelected(new Set());
  }

  return { selected, toggle, toggleAll, clear };
}
